export enum ConnectionStatus {
    CONNECTING,
    CONNECTED,
    ERROR,
    DISCONNECTING,
    DISCONNECTED,
    TIMED_OUT
}